import { urlFor } from "@/utils/client";
import { setConsent } from "@/utils/consent";
import { ISettings } from "@/utils/types";
import Image from "next/image";
import Link from "next/link";
import { Button } from "./button";

export function Footer({ data }: { data: ISettings }) {
  return (
    <footer className="pt-16 bg-darkGrey text-white w-full">
      <div className="max-w-page m-auto p-4 flex flex-col gap-16  justify-between items-start">
        <Image
          src="/logo.svg"
          className="invert"
          alt="Logo"
          width={125}
          height={50}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full justify-between items-start">
          <div className="flex flex-col gap-8">
            {data.footerNav?.length > 0 && (
              <nav className="flex flex-col justify-between items-start gap-4">
                <p className="font-display">Sitemap</p>
                <div className="grid grid-cols-2 gap-4">
                  {data.footerNav
                    .filter((item) => item.link)
                    .map((item, i) => (
                      <Link key={i} href={item.link}>
                        {item.label}
                      </Link>
                    ))}
                </div>
              </nav>
            )}
            <div>
              <p className="font-display">Een initiatief van</p>
              <div className="flex flex-wrap gap-4 mt-2">
                {(data.logos ?? []).map((logo, i) => {
                  if (!logo?.image) return null;
                  return (
                    <Image
                      className="object-contain w-[50px] h-[40px]"
                      key={i}
                      width={120}
                      height={120}
                      alt={logo?.caption ?? ""}
                      src={urlFor(logo.image).url()}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <p className="font-display">Contact</p>
              <p className="opacity-75">{data.mail}</p>
            </div>
            <div>
              <p className="font-display">Kanalen</p>
              <div className="flex flex-wrap gap-2 mt-2">
                {(data.socials ?? []).map((social, i) => {
                  if (!social?.link || !social?.icon) return null;
                  return (
                    <a
                      href={social.link}
                      key={i}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        className="object-contain aspect-square w-[30px]"
                        width={120}
                        height={120}
                        alt={`Icon for social media`}
                        src={urlFor(social.icon).url()}
                      />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col gap-2 items-start">
            <p className="font-display">Nieuwsbrief</p>
            <p className="opacity-75">{data.newsletter}</p>
            {data.newsletterLink && <Button label="Abonneer" link={data.newsletterLink} />}
          </div>
        </div>
      </div>
      <div className="w-full bg-black gap-4">
        <div className="max-w-page p-4 m-auto w-full flex flex-wrap justify-between items-center">
          <div className="flex flex-wrap gap-4">
            {(data.docs ?? []).map((doc, i) => {
              return (
                <a
                  target="_blank"
                  rel="noreferrer"
                  key={i}
                  className="opacity-75 hover:opacity-100"
                  href={doc.fileURL ? doc.fileURL : doc.link}
                >
                  {doc.label}
                </a>
              );
            })}
            {/* Clearing the stored choice makes the consent banner reappear. */}
            <button
              type="button"
              className="opacity-75 hover:opacity-100"
              onClick={() => setConsent(null)}
            >
              Cookie-instellingen
            </button>
          </div>
          <p className="opacity-50">{new Date().getFullYear()}</p>
        </div>
      </div>
    </footer>
  );
}
